// eslint-disable-next-line
import i18n from 'i18n';
import i18next from 'i18next';
import { SURVEY_PROPS_ORDER, VEHICLES_TYPES, REGIONS } from 'constants/survey';
import { TRUCK_FLOW } from '../constants/decisionFlows/truckFlow';
import { CAR_VAN_FLOW } from '../constants/decisionFlows/carVanFlow';
import { TAXI_FLOW } from '../constants/decisionFlows/taxiFlow';
import { MIX_FLOW } from '../constants/decisionFlows/mixFlow';
import { OTHER_FLOW } from '../constants/decisionFlows/otherFlow';

/**
 * Given a vehicle, returns an object with all its posible answer combinations
 * @param {String} vehicleType
 * @returns {Object} object with all posible answer combinations
 */
const getCombinationsMatrix = (vehicleType) => {
  switch(vehicleType) {
    case i18next.t(VEHICLES_TYPES.TRUCK):
      return { ...TRUCK_FLOW }
    case i18next.t(VEHICLES_TYPES.CAR):
    case i18next.t(VEHICLES_TYPES.VAN):
      return { ...CAR_VAN_FLOW }
    case i18next.t(VEHICLES_TYPES.TAXI):
      return { ...TAXI_FLOW }
    case i18next.t(VEHICLES_TYPES.MIX):
      return { ...MIX_FLOW }
    case i18next.t(VEHICLES_TYPES.OTHER):
      return { ...OTHER_FLOW }
    default:
  }
}

/**
 * Surfs through the RESULT object using survey values (user selections) as properties
 * until it finds a "result" object with card name and redirection URL.
 *
 * - e.g. If user selection (survey) is:
 *
 * vehicleType: 'Turismo',
 * vehiclesAmount: '2-5',
 * routeType: 'Regional',
 * region: 'Pontevedra', // Capillarity 'baja'
 * bill: '', // Only Taxi
 * credit: 'Si'
 *
 * - Then te result will be
 * RESULT['Turismo']['2-5']['Regional']['baja']['Si']
 *
 * - So it will return
 * result: {
 * 'CARD_NAME': 'StarRessa Direct (Nacional)',
 * 'URL': '/transportista/recomendador/direct-nacional'
 * }
 *
 * @param {Object} survey
 * @returns {Object} result - Object with the result
 */
export const getResult = (survey) => {

  let cardResult = getCombinationsMatrix(survey.vehicleType);
  let found = false;

  // Loops throug each survey prop by order
  // ['vehicleType', 'vehiclesAmount', 'routeType', 'region', 'bill', 'credit']
  SURVEY_PROPS_ORDER.forEach((key) => {

    let surveyKey = survey[key];

    // If value is empty (because is a skipped step, not asked to user),
    // returns false to go to the next prop
    if (found || surveyKey === '') {
      return false;
    }

    if (key === 'routeType') {
      // routeType is an array-like string "Internacional,Regional"
      surveyKey = surveyKey.split(',')[0];
    } else if (key === 'region') {
      // Get capillarity from a region
      surveyKey = REGIONS[surveyKey];
    }

    // Looks in cardResult if current key (e.g. "Turismo") exists
    let resultVal = cardResult[surveyKey];

    if (resultVal) {
      let objKeys = Object.keys(resultVal);
      if (objKeys && objKeys.length) {
        // Searches in current Key if there is a result object (end of the flow)
        if (objKeys.indexOf('result') !== -1) {
          // Saves result object and sets found as true to skip rest of the forEach loop
          found = true;
          cardResult = resultVal['result'];
        } else {
          // Else cardResult is positioned in the current object (e.g. cardResult['Truck'])
          // and keeps searching with next property in next loop iteration
          cardResult = resultVal;
        }
      } else {
        // current object is empty (has no keys), skip rest of the forEach loop
        cardResult = undefined;
        found = true;
      }
    } else {
      // current key (e.g. "Turismo") doesn't exist, skip rest of the forEach loop
      cardResult = undefined;
      found = true;
    }
  });

  return cardResult;
};

/**
 * Stores in sessionStorage all user selections and redirects to the result page
 * @param {Object} survey - object with all user selections
 */
export const handleResult = (survey) => {
  let card = getResult(survey);

  /*if (card && (card.URL_ES.undefined || card.URL_EN.undefined) && card.CARD_NAME.undefined) {*/
  if (card && card.URL_PT !== undefined && card.CARD_NAME !== undefined) {
    let result = {
      ...survey,
      cardType: card.CARD_NAME
    }

    // Convert any empty string to null
    Object.keys(result).forEach((key) => {
      if (result[key] === '') {
        result[key] = null;
      }
    });

    // Save result in sessionStorage and redirect to result page
    /*const urlRedirect = i18next.language === 'es' ? card.URL_ES : card.URL_EN;*/
    const urlRedirect = card.URL_PT;
    let resultURL = `${document.location.origin}/${ i18next.language }${ urlRedirect }`
    sessionStorage.setItem('prefillFormConfigurable', JSON.stringify(result));

    window.location = resultURL;
  }
};
